
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf",
      function () {
        return require("private-next-pages/golf/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf"])
      });
    }
  